
    <svg class="icon-truck" [attr.width]="iconWidth" [attr.height]="iconHeight" viewBox="0 0 46 24" *ngIf="fastCheckout">
        <use xlink:href="/images/icons/svg-sprite.svg#truck"></use>
    </svg>
    <svg class="icon-shoppingcart" [attr.width]="iconWidth" [attr.height]="iconHeight" viewBox="0 0 27 24" *ngIf="!fastCheckout">
        <use xlink:href="/images/icons/svg-sprite.svg#shoppingcart"></use>
    </svg>